export const commissionCore: Record<string, string> = {
  // Page shell
  'comm.tabStatistics': 'Thống kê',
  'comm.tabDistribution': 'Phân bổ',
  'comm.tabIap': 'IAP',
  'comm.tabConfig': 'Cấu hình',
  'comm.loadError': 'Tải thất bại',

  // Statistics tab
  'comm.department': 'Bộ phận',
  'comm.netProfit': 'Lợi nhuận ròng',
  'comm.commRate': 'Tỷ lệ hoa hồng',
  'comm.totalVND': 'Tổng VND',
  'comm.items': 'Chi tiết',
  'comm.autoCalculated': 'Tự động',
  'comm.confirmed': 'Đã chốt',
  'comm.statisticsConfirmed': 'Kỳ này đã được chốt.',
  'comm.confirmPeriod': 'Chốt kỳ',
  'comm.total': 'Tổng cộng',
  'comm.noData': 'Không có dữ liệu',
  'comm.employeeMatrix': 'Hoa hồng theo nhân viên',
  'comm.projectGroup': 'Nhóm dự án',

  // Distribution tab
  'comm.selectGroup': 'Chọn nhóm dự án',
  'comm.selectGroupHint': 'Chọn nhóm dự án + phòng ban rồi bấm Tải.',
  'comm.gross': 'Gross',
  'comm.grossFormula': 'Gross Profit = IAP + Doanh thu ròng AdMob − Chi phí Ads',
  'comm.netProfitFormula': 'Net Profit = Gross × Tỷ lệ đối tác − Chi phí khác',
  'comm.netProfitFormulaExternalDev': 'Net Profit = Gross × (Tỷ lệ đối tác − Tỷ lệ dev) − Chi phí khác · dev ngoài',
  'comm.netProfitFormulaDevShare': 'Net Profit = (Gross − Chi phí khác) × (100% − Tỷ lệ dev) · công thức riêng',
  'comm.netProfitFormulaUnknown': 'Net Profit do server tính theo công thức riêng của sản phẩm này',
  'comm.rateDev': 'Tỷ lệ dev',
  'comm.rateAfterDev': 'Còn lại sau dev',
  'comm.rateEffective': 'Tỷ lệ áp dụng',
  'comm.refRevenueSys': 'Tham chiếu: Doanh thu (Hệ thống)',
  'comm.totalCommission': 'Tổng hoa hồng',
  'comm.exchangeRate': 'Tỷ giá',
  'comm.statusConfirmed': 'Đã xác nhận',
  'comm.statusSaved': 'Đã lưu · chưa chốt',
  'comm.exportXlsx': 'Xuất XLSX',
  'comm.awaitingNetRev': 'Chờ Net Rev',
  'comm.hiddenNoProfit': 'Đã ẩn {n} sản phẩm chưa chia được (lỗ hoặc chưa có Net Rev)',
  'comm.showAllProducts': 'Hiện tất cả',
  'comm.showOnlyPayable': 'Chỉ hiện chia được',
  'comm.statusAuto': 'Tự động',
  'comm.uaNoSourceNote': 'Chưa tính được hoa hồng UA cho kỳ này. UA chỉ được tính khi đã có Net Rev (tab Config) và lợi nhuận ròng lớn hơn 0.',
  'comm.previewNote': 'Chưa lưu. Các số này tính từ config hiện tại, đúng bằng số sẽ được ghi khi bấm Save.',
  'comm.previewZeroNote': 'Chưa lưu. Kỳ này không có lợi nhuận ròng nên hoa hồng bằng 0 — không chia được tỷ lệ.',
  'comm.uaAutoNote': 'Bộ phận UA được tính tự động, không cần phân bổ thủ công.',
  'comm.netRevenueAdmob': 'Doanh thu ròng AdMob',
  'comm.adsCost': 'Chi phí quảng cáo',
  'comm.otherCosts': 'Chi phí khác',
  'comm.calc': 'Tính',
  'comm.ratePartner': 'Tỷ lệ đối tác',
  'comm.employee': 'Nhân viên',
  'comm.rate': 'Tỷ lệ',
  'comm.amount': 'Số tiền',
  'comm.note': 'Ghi chú',
  'comm.totalRate': 'Tổng tỷ lệ',
  'comm.remaining': 'Còn lại',
  'comm.noEmployees': 'Bộ phận chưa có nhân viên',
  'comm.recordConfirmedNote': 'Bản ghi này đã được chốt, không thể sửa.',
  'comm.saveError': 'Lưu thất bại',
  'comm.saveSuccess': 'Đã lưu',
  'comm.confirmSuccess': 'Đã chốt',
  'comm.deleteConfirm': 'Xóa bản ghi phân bổ này?',
  'comm.deleteSuccess': 'Đã xóa',
  'comm.invalidTotalRate': 'Tổng tỷ lệ vượt quá 100%',
  'comm.versionConflict': 'Dữ liệu đã bị thay đổi ở nơi khác, vui lòng tải lại.',

  // IAP tab
  'comm.grossRevenue': 'Doanh thu gộp',
  'comm.googleFee': 'Phí Google',
  'comm.refunds': 'Hoàn tiền',
  'comm.otherFees': 'Phí khác',
  'comm.netIap': 'IAP ròng',
  'comm.app': 'App',
  'comm.type': 'Loại',

  // My tab
  // Support commission (fixed VND by level, gated on Falcon - ES net profit)
  'comm.support.title': 'Hoa hồng Support (HR / IC / Kế toán / CFO / Designer)',
  'comm.support.title_': 'Chức danh',
  'comm.support.level': 'Cấp',
  'comm.support.gatePassed': 'Đủ điều kiện chia',
  'comm.support.gateFailed': 'Chưa đủ điều kiện — không chia',
  'comm.support.threshold': 'ngưỡng',
  'comm.support.awaiting': 'app chưa nhập Net Rev',
  'comm.support.snapshot': 'Đã chốt (snapshot)',
  'comm.support.nobody': 'Không có nhân sự Support đủ điều kiện kỳ này.',
  'comm.support.excluded': 'Không chia',
  'comm.support.reason.not_employed_through_month': 'chưa/không còn làm đến cuối tháng',
  'comm.support.reason.remote': 'hợp đồng remote',
  'comm.support.reason.intern': 'thực tập',
  'comm.support.reason.level_unmapped': 'cấp chưa có mức hưởng',
  'comm.support.reason.in_product_pool': 'đã nhận qua quỹ Product',
  'comm.support.liveWarning': 'Kỳ đã chốt nhưng Support chưa đóng băng — đang tính từ dữ liệu hiện tại',
  'comm.support.refresh': 'Chốt lại Support',
  'comm.support.refreshTitle': 'Tính lại từ dữ liệu hiện tại và ghi đè snapshot của kỳ này',
}
